import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { datosMundo } from '../../services/mundo';
import { iniciarMundo } from './mundoEngine';
import './MiMundo.css';

const DATOS = datosMundo();
const BASE = process.env.PUBLIC_URL || '';

/**
 * Globo interactivo "Mi mundo".
 * React solo es dueño del contenedor; el motor (mundoEngine.js) pinta el interior
 * y anima cámara, pines y polaroids por frame sin re-renders de React.
 *
 * ref → { focoLugar(lugarId), verLugarEnGlobo(lugarId), verViaje(viajeId), verDestino(destinoId) }
 * verLugarEnGlobo solo actúa en el celular (abre el lugar y baja al globo) y devuelve si se encargó.
 */
const MiMundo = forwardRef(function MiMundo({ estilo = 'realista' }, ref) {
  const el = useRef(null);
  const api = useRef(null);

  useEffect(() => {
    api.current = iniciarMundo(el.current, DATOS, { estilo, base: BASE });
    return () => { api.current.destroy(); api.current = null; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { if (api.current) api.current.setEstilo(estilo); }, [estilo]);

  useImperativeHandle(ref, () => ({
    focoLugar: (id) => api.current && api.current.focoLugar(id),
    verLugarEnGlobo: (id) => !!api.current && api.current.verLugarEnGlobo(id),
    verViaje: (id) => api.current && api.current.verViaje(id),
    verDestino: (id) => api.current && api.current.verDestino(id)
  }), []);

  return (
    <section id="mundo" className={`mundo mundo--${estilo}`} aria-label="Mi mundo: el mapa de mis viajes">
      {/* sin className/data-*: el motor administra las clases (.mm, .movil) de este nodo */}
      <div ref={el} />
    </section>
  );
});

export default MiMundo;
